function Notification() {
  return (
    <div className="absolute top-10 right-10 rounded-md py-3 px-5 bg-secondary text-white">
      Kosa kata berhasil ditambahkan
    </div>
  );
}

export default Notification;
